import {
  Component,
  Input,
  OnChanges,
  OnInit,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {
  GoogleMap,
  MapInfoWindow,
  MapPolygon,
  MapPolyline,
} from '@angular/google-maps';
import {
  IAmbiente,
  ICoordenadas,
  IEstacionMeteorologica,
  IFreatimetro,
  ILuminaria,
  IPluviometro,
  IPolyline,
  ISensorHumedadSuelo,
  IUbicacion,
} from 'modelos/src';
import { DialogService } from '../dialog/dialog.service';
import { HelperService } from '../helper.service';
import { LuminariasService } from 'src/app/modulos/aplicaciones/luminarias/service';
import { MatDialog } from '@angular/material/dialog';
import { DetallesModalComponent } from 'src/app/modulos/aplicaciones/luminarias/luminarias-map/detalles-modal/detalles-modal.component';

interface PolygonOptionsWithId extends google.maps.PolygonOptions {
  _id?: string;
}

interface PolylineOptionssWithId extends google.maps.PolylineOptions {
  _id?: string;
}

export interface IUbicacionConId extends IUbicacion {
  _id?: string;
}

@Component({
  selector: 'app-polygon-draw',
  templateUrl: './polygon-draw.component.html',
  styleUrls: ['./polygon-draw.component.scss'],
})
export class PolygonDrawComponent implements OnInit, OnChanges {
  public dibujando = true;
  @Input() mapTypeId: google.maps.MapTypeId = google.maps.MapTypeId.SATELLITE;
  @Input() showMapTypeControl: boolean = true;
  @Input() showMaptypeControlPosition: google.maps.ControlPosition =
    google.maps.ControlPosition.TOP_RIGHT;

  @Input() showZoomMapControl: boolean = true;
  @Input() showZoomMapControlPosition: google.maps.ControlPosition =
    google.maps.ControlPosition.TOP_LEFT;

  // Poligono a dibujar
  @Input() multiple: boolean = false;
  @Input() esPolyline: boolean = false;
  @Input() ubicaciones?: IUbicacionConId[] = [];
  @Input() ambiente?: IAmbiente;
  @Input() selectAmbiente?: (
    id: string | undefined,
    callback?: () => void,
  ) => Promise<void>;
  @Input() lineas: IPolyline[] = [];
  @Input() editable: boolean = true;

  @Input() cLinea?: string;
  @Input() cRelleno?: string;
  @Input() opacidad?: number;

  @Input() cLineaSelectedUbicacion?: string;
  @Input() cRellenoSelectedUbicacion?: string;
  @Input() opacidadSelectedUbicacion?: number;

  // Mapa
  @Input() height: string = '50vh';
  @Input() zoom: number = 15;
  @ViewChild(GoogleMap, { static: false }) map: GoogleMap | undefined;
  @Input() public center?: google.maps.LatLngLiteral;
  public mapOptions?: google.maps.MapOptions;

  // Sensores
  @Input() ubicacionSensoresHumedadSuelo: ISensorHumedadSuelo[] = [];
  @Input() ubicacionPluviometros: IPluviometro[] = [];
  @Input() ubicacionEstacion: IEstacionMeteorologica[] = [];
  @Input() ubicacionFreatimetro: IFreatimetro[] = [];
  @Input() ubicacionLuminaria: ILuminaria[] = [];

  // luminarias filtrada
  public luminariasFiltradas: ILuminaria[] = [];

  // Otros Poligonos Fijos de referencia
  @Input() otrasUbicaciones: IUbicacion[] = [];
  @ViewChildren(MapPolygon) polygonRef?: QueryList<MapPolygon>;
  @ViewChildren(MapPolyline) polylineRef?: QueryList<MapPolyline>;
  public polygonOptions: PolygonOptionsWithId[] = [];
  public polylineOptions: PolylineOptionssWithId[] = [];
  public selectedPoly?: number;

  private markers: google.maps.Marker[] = [];

  // Info Window
  @ViewChild(MapInfoWindow) infoWindow?: MapInfoWindow;

  // Dibujo de poligono
  public drawingManager = new google.maps.drawing.DrawingManager({
    polygonOptions: {
      editable: this.editable === false ? false : true,
      draggable: false,
      clickable: true,
      zIndex: 100,
      strokeColor: this.cLinea,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: this.cRelleno,
      fillOpacity: 0.35,
    },
    polylineOptions: {
      editable: this.editable === false ? false : true,
      draggable: false,
      clickable: true,
      zIndex: 100,
      strokeColor: this.cLinea,
      strokeOpacity: 0.8,
      strokeWeight: 5,
    },
    drawingMode:
      this.esPolyline && this.editable === true
        ? google.maps.drawing.OverlayType.POLYLINE
        : google.maps.drawing.OverlayType.POLYGON,
    drawingControl: true,
    drawingControlOptions: {
      position: google.maps.ControlPosition.TOP_CENTER,
      drawingModes: [
        this.esPolyline
          ? google.maps.drawing.OverlayType.POLYLINE
          : google.maps.drawing.OverlayType.POLYGON,
      ],
    },
  });

  get polygons(): ICoordenadas[][] {
    const response: ICoordenadas[][] = [];
    if (this.polygonRef) {
      const polygons = this.polygonRef.toArray();
      for (const polygon of polygons) {
        response.push(
          polygon
            ?.getPath()
            ?.getArray()
            .map((position) => {
              return { lat: position.lat(), lng: position.lng() };
            }),
        );
      }
    }
    return response;
  }

  get polylines(): ICoordenadas[][] {
    const response: ICoordenadas[][] = [];
    if (this.polylineRef) {
      const polygons = this.polylineRef.toArray();
      for (const polygon of polygons) {
        response.push(
          polygon
            ?.getPath()
            ?.getArray()
            .map((position) => {
              return { lat: position.lat(), lng: position.lng() };
            }),
        );
      }
    }
    return response;
  }

  get getUbicaciones(): IUbicacion[] {
    const ubicaciones: IUbicacion[] = [];
    for (const polygon of this.polygons) {
      ubicaciones.push({
        poligono: polygon,
        nombre: '',
        centro: this.getCentro(polygon),
        superficie: this.calcularArea(polygon),
      });
    }
    return ubicaciones;
  }

  get getLineas(): IPolyline[] {
    const lineas: IPolyline[] = [];
    console.log(`poly en get`, this.polylines);

    for (const polyline of this.polylines) {
      lineas.push(polyline);
    }
    return lineas;
    // const lineas: IPolyline[] = [];
    // for (const polyline of this.polylineOptions) {
    //   lineas.push(polyline.path as IPolyline);
    // }
    // return lineas;
  }

  constructor(
    private helper: HelperService,
    private dalogService: DialogService,
    private luminariasService: LuminariasService,
    private dialog: MatDialog,
  ) { }

  private getCentro(coordenadas?: ICoordenadas[]): ICoordenadas {
    if (coordenadas?.length) {
      const newPolygon: ICoordenadas[] = JSON.parse(
        JSON.stringify(coordenadas),
      );
      const longitudes = newPolygon.map((i) => i.lat);
      const latitudes = newPolygon.map((i) => i.lng);
      latitudes.sort((a, b) => a - b);
      longitudes.sort((a, b) => a - b);
      const lowX = latitudes[0];
      const highX = latitudes[latitudes.length - 1];
      const lowy = longitudes[0];
      const highy = longitudes[latitudes.length - 1];
      const centerX = lowX + (highX - lowX) / 2;
      const centerY = lowy + (highy - lowy) / 2;
      const center: ICoordenadas = {
        lng: centerX,
        lat: centerY,
      };
      return center;
    }
    return { lng: 0, lat: 0 };
  }
  private calcularAreas(poligonos: ICoordenadas[][]): number {
    if (poligonos?.length) {
      let area = 0;
      for (const poly of poligonos) {
        area += this.calcularArea(poly);
      }
      return +area.toFixed(2);
    }
    return 0;
  }
  private calcularArea(poligono: ICoordenadas[]): number {
    if (poligono?.length > 2) {
      const poly = new google.maps.Polygon({ paths: poligono });
      const area = google.maps.geometry.spherical.computeArea(poly.getPath());
      return +(area / 10000).toFixed(2);
    }
    return 0;
  }

  async handlePolygonClick(
    event: google.maps.PolyMouseEvent,
    polygon: any,
  ): Promise<void> {
    if (polygon._id === this.ambiente?._id) {
      await this.mostrarInfoWindow(event, polygon);
    } else if (this.selectAmbiente && polygon?._id !== this.ambiente?._id) {
      await this.selectAmbiente(polygon._id, () =>
        this.mostrarInfoWindow(event, polygon),
      );
    }
  }

  async handlePolylineClick(
    event: google.maps.PolyMouseEvent,
    polyline: any,
  ): Promise<void> {
    if (polyline._id === this.ambiente?._id) {
      await this.mostrarInfoWindow(event, polyline);
    } else if (this.selectAmbiente && polyline?._id !== this.ambiente?._id) {
      await this.selectAmbiente(polyline._id, () =>
        this.mostrarInfoWindow(event, polyline),
      );
    }
  }

  public async mostrarInfoWindow(
    event: google.maps.PolyMouseEvent,
    poli?: any,
  ) {
    if (this.infoWindow) {
      this.selectedPoly = poli._id;
      this.infoWindow.position = event.latLng!;
      this.infoWindow.options = {
        maxWidth: 500,
        minWidth: 400,
      };
      this.infoWindow!.open();
    }
  }

  public async eliminar() {
    const confirm = await this.dalogService.confirm(
      'Por favor confirme la acción',
      this.esPolyline
        ? '¿Eliminar la polyline seleccionada?'
        : '¿Eliminar el polígono seleccionado?',
    );
    if (confirm) {
      if (this.esPolyline) {
        const polylines = this.polylines;
        polylines.splice(this.selectedPoly!, 1);
        const polylinesOptions = [];
        for (const poly of polylines) {
          polylinesOptions.push({
            paths: poly,
            clickable: true,
            editable: this.editable === false ? false : true,
            draggable: false,
            zIndex: 1,
            strokeColor: this.cLinea,
            strokeOpacity: 0.8,
            strokeWeight: 5,
          });
        }
        this.polylineOptions = polylinesOptions;
        this.helper.notifSuccess('Polígono eliminado');
      } else {
        const polygons = this.polygons;
        polygons.splice(this.selectedPoly!, 1);
        const polygonsOptions = [];
        for (const poly of polygons) {
          polygonsOptions.push({
            paths: poly,
            clickable: true,
            editable: this.editable === false ? false : true,
            draggable: false,
            zIndex: 1,
            strokeColor: this.cLinea,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: this.cRelleno,
            fillOpacity: 0.35,
          });
        }
        this.polygonOptions = polygonsOptions;
        this.helper.notifSuccess('Polígono eliminado');
      }
    }
    this.infoWindow?.close();
  }

  public dibujar() {
    if (this.map?.googleMap) {
      this.initDrawingManager();
      this.drawingManager.setMap(this.map?.googleMap || null);
      this.dibujando = true;
    } else {
      setTimeout(() => this.dibujar(), 50);
    }
  }

  public listenDrawEnd() {
    google.maps.event.addListener(
      this.drawingManager,
      'overlaycomplete',
      async (event: any) => {
        // Polygon drawn
        if (!this.esPolyline) {
          if (event.type === google.maps.drawing.OverlayType.POLYGON) {
            const coordenadas: ICoordenadas[] = [];
            event.overlay
              .getPath()
              .getArray()
              .forEach((position: any) => {
                const pos: ICoordenadas = {
                  lat: position.lat(),
                  lng: position.lng(),
                };
                coordenadas.push(pos);
              });
            this.polygonOptions.push({
              draggable: false,
              editable: this.editable === false ? false : true,
              clickable: true,
              paths: coordenadas,
              zIndex: 100,
              strokeColor: this.cLinea,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: this.cRelleno,
              fillOpacity: 0.35,
            });
            this.dibujando = false;
            event.overlay.setMap(null);
            this.drawingManager.setMap(null);
          }
        }
        // Polyline drawn
        if (this.esPolyline) {
          if (event.type === google.maps.drawing.OverlayType.POLYLINE) {
            const coordenadas: ICoordenadas[] = [];
            event.overlay
              .getPath()
              .getArray()
              .forEach((position: any) => {
                const pos: ICoordenadas = {
                  lat: position.lat(),
                  lng: position.lng(),
                };
                coordenadas.push(pos);
              });

            this.polylineOptions.push({
              draggable: false,
              editable: this.editable === false ? false : true,
              clickable: true,
              path: coordenadas,
              zIndex: 100,
              strokeColor: this.cLinea,
              strokeOpacity: 0.8,
              strokeWeight: 5,
            });
            this.dibujando = false;
            event.overlay.setMap(null);
            this.drawingManager.setMap(null);
          }
        }
      },
    );
  }

  public cancelarDibujo() {
    this.dibujando = false;
    this.drawingManager.setMap(null);
  }

  private async setMapOptions() {
    this.mapOptions = {
      ...JSON.parse(JSON.stringify(HelperService.mapOptionsMarkerPicker)),
      zoom: this.zoom,

      mapTypeId: this.mapTypeId,
      mapTypeControl: this.showMapTypeControl,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DEFAULT,
        position: this.showMaptypeControlPosition,
      },
      zoomControl: this.showZoomMapControl,
      zoomControlOptions: {
        position: this.showZoomMapControlPosition,
      },
      styles: [
        {
          featureType: 'poi',
          elementType: 'labels',
          stylers: [{ visibility: 'off' }], // Oculta los puntos de interés (marcadores de Google)
        },
      ],
    };
  }

  private initDrawingManager() {
    if (this.esPolyline) {
      this.drawingManager = new google.maps.drawing.DrawingManager({
        polylineOptions: {
          editable: this.editable === false ? false : true,
          draggable: false,
          clickable: true,
          zIndex: 100,
          strokeColor: this.cLinea,
          strokeOpacity: 0.8,
          strokeWeight: 5,
        },
        drawingMode:
          this.editable === false
            ? null
            : google.maps.drawing.OverlayType.POLYLINE,
        drawingControl: this.editable === false ? false : true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [google.maps.drawing.OverlayType.POLYLINE],
        },
      });
    } else {
      this.drawingManager = new google.maps.drawing.DrawingManager({
        polygonOptions: {
          editable: this.editable === false ? false : true,
          draggable: false,
          clickable: true,
          zIndex: 100,
          strokeColor: this.cLinea,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: this.cRelleno,
          fillOpacity: 0.35,
        },
        drawingMode:
          this.editable === false
            ? null
            : google.maps.drawing.OverlayType.POLYGON,
        drawingControl: this.editable === false ? false : true,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [google.maps.drawing.OverlayType.POLYGON],
        },
      });
    }

    this.listenDrawEnd();
  }

  private processUbicaciones() {
    this.polygonOptions = [];
    if (this.ubicaciones !== undefined && this.ubicaciones.length > 0) {
      this.center = this.ubicaciones[0].centro;
      if (!this.center) {
        this.center = this.ubicaciones[0].centro || {
          lat: -34.603722,
          lng: -58.381592,
        };
      }
      for (const ubicacion of this.ubicaciones) {
        this.polygonOptions.push({
          draggable: false,
          editable: this.editable === false ? false : true,
          paths: ubicacion.poligono,
          strokeColor: this.cLineaSelectedUbicacion,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: this.cRellenoSelectedUbicacion,
          fillOpacity: 0.35,
          _id: ubicacion._id,
        });
      }
    }
    if (this.ambiente !== undefined && this.ambiente.ubicacion) {
      this.center = this.ambiente.ubicacion.centro;
      if (!this.center) {
        this.center = this.ambiente?.ubicacion?.centro || {
          lat: -34.603722,
          lng: -58.381592,
        };
      }
      this.polygonOptions.push({
        draggable: false,
        editable: this.editable === false ? false : true,
        paths: this.ambiente.ubicacion.poligono,
        strokeColor: this.cLinea,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: this.cRelleno,
        fillOpacity: 0.35,
        _id: this.ambiente._id,
      });
    }
  }

  private async initMap() {
    await this.setMapOptions();
    await this.updateMarkers();
    if (this.esPolyline) {
      if (this.lineas?.length > 0) {
        if (!this.center) {
          this.center = this.lineas[0][0] || {
            lat: -34.603722,
            lng: -58.381592,
          };
        }
        for (const linea of this.lineas) {
          this.polylineOptions.push({
            draggable: false,
            editable: this.editable === false ? false : true,
            path: linea,
            strokeColor: this.cLinea,
            strokeOpacity: 0.8,
            strokeWeight: 5,
          });
        }
        this.dibujando = false;
      } else if (this.otrasUbicaciones.length) {
        if (!this.center) {
          this.center = this.otrasUbicaciones[0].centro;
        }
        this.dibujar();
        this.dibujando = false;
      } else {
        const ubicacion = await HelperService.getCurrentPosition();
        if (!this.center) {
          this.center = ubicacion;
        }
        this.dibujar();
        this.dibujando = false;
      }
    } else {
      if (this.ubicaciones !== undefined && this.ubicaciones?.length > 0) {
        this.processUbicaciones();
        this.dibujando = false;
      } else if (this.ambiente !== undefined && this.ambiente.ubicacion) {
        this.processUbicaciones();
        this.dibujando = false;
      } else {
        const ubicacion = await HelperService.getCurrentPosition();
        if (!this.center) {
          this.center = ubicacion;
        }
        this.dibujar();
        this.dibujando = false;
      }
    }
  }

  public mostrarCrear() {
    if (this.dibujando) return false;

    if (this.multiple) return true;

    if (this.esPolyline) {
      const polylines = this.polylineRef?.toArray();
      if (polylines && polylines.length < 1) return true;
    } else {
      const polygons = this.polygonRef?.toArray();
      if (polygons && polygons.length < 1) return true;
    }

    return false;
  }

  private openDetallesModal(luminaria: ILuminaria): void {
    this.dialog.open(DetallesModalComponent, {
      width: '80%',
      data: { luminaria: luminaria },
    });
  }

  private async addMarker(
    location: ICoordenadas,
    title: string,
    iconUrl: string = '',
    luminaria?: ILuminaria,
  ) {
    const marker = new google.maps.Marker({
      position: { lat: location.lat, lng: location.lng },
      map: this.map?.googleMap,
      title: title,
      icon: {
        url: iconUrl,
        scaledSize: new google.maps.Size(50, 50),
      },
    });

    if (luminaria) {
      marker.addListener('click', () => {
        this.openDetallesModal(luminaria);
      });
    }
    this.markers.push(marker);
  }

  private clearMarkers() {
    this.markers.forEach((marker) => marker.setMap(null));
    this.markers = [];
  }

  actualizarLuminariasFiltradas(): void {
    this.luminariasFiltradas =
      this.luminariasService.obtenerLuminariasFiltradas(
        this.ubicacionLuminaria,
      );
  }

  private async updateMarkers() {
    this.clearMarkers();

    // Icon URLs
    const shsIconUrl = '../../../assets/svg/map/shs-map.svg';
    const pluviometroIconUrl = '../../../assets/svg/map/pluviometro-map.svg';
    const estacionIconUrl = '../../../assets/svg/map/estacion-map.svg';
    const freatimetroIconUrl = '../../../assets/svg/map/freatimetro-map.svg';

    // Luminarias
    if (this.luminariasFiltradas.length > 0) {
      this.luminariasFiltradas.forEach((sensor) => {
        if (
          (sensor?.ubicacion !== null && sensor?.ubicacion !== undefined) ||
          (sensor?.dispositivo?.config?.location !== null &&
            sensor?.dispositivo?.config?.location !== undefined)
        ) {
          this.addMarker(
            sensor?.ubicacion || sensor?.dispositivo?.config?.location,
            'Luminaria',
            this.luminariasService.determinarEstadoLuminaria(sensor).iconoMapa,
            sensor,
          );
        }
      });
    }

    //ubicacionSensoresHumedadSuelo
    if (this.ubicacionSensoresHumedadSuelo.length > 0) {
      this.ubicacionSensoresHumedadSuelo.forEach((sensor) => {
        if (sensor?.ubicacion?.coordenadas !== undefined) {
          this.addMarker(
            sensor?.ubicacion?.coordenadas,
            'Sensor de Humedad de Suelo',
            shsIconUrl,
          );
        }
      });
    }

    // pluviometros
    if (this.ubicacionPluviometros.length > 0) {
      this.ubicacionPluviometros.forEach((sensor) => {
        if (sensor?.ubicacion?.coordenadas !== undefined) {
          this.addMarker(
            sensor?.ubicacion?.coordenadas,
            'Pluviómetro',
            pluviometroIconUrl,
          );
        }
      });
    }

    // Estaciones Meteorologicas
    if (this.ubicacionEstacion.length > 0) {
      this.ubicacionEstacion.forEach((sensor) => {
        if (sensor?.ubicacion?.coordenadas !== undefined) {
          this.addMarker(
            sensor?.ubicacion?.coordenadas,
            'Estación Meteorológica',
            estacionIconUrl,
          );
        }
      });
    }

    // Freatimetros
    if (this.ubicacionFreatimetro.length > 0) {
      this.ubicacionFreatimetro.forEach((sensor) => {
        if (sensor?.ubicacion?.coordenadas !== undefined) {
          this.addMarker(
            sensor?.ubicacion?.coordenadas,
            'Freatímetro',
            freatimetroIconUrl,
          );
        }
      });
    }
  }

  async ngOnChanges(changes: SimpleChanges) {
    this.processUbicaciones();
    this.infoWindow?.close();
    this.dibujando = false;
    const otrasUbicaciones = this.otrasUbicaciones;

    if (
      changes.ubicacionSensoresHumedadSuelo ||
      changes.ubicacionPluviometros ||
      changes.ubicacionEstacion ||
      changes.ubicacionFreatimetro ||
      changes.ubicacionLuminaria
    ) {
      this.updateMarkers();
    }

    if (otrasUbicaciones.length && !this.getUbicaciones?.length) {
      this.center = otrasUbicaciones[0].centro;
    }

    if (changes.cLinea) {
      this.cLinea = changes.cLinea.currentValue;
    }

    if (changes.cRelleno) {
      this.cRelleno = changes.cRelleno.currentValue;
    }
  }

  async ngOnInit(): Promise<void> {
    // Suscribirse a los cambios en los filtros activos
    this.luminariasService.filtrosActivos$.subscribe((filtros) => {
      this.actualizarLuminariasFiltradas();
      this.updateMarkers();
    });
    await this.initMap();
  }
}
